export default __webpack_public_path__ + "static/media/product-1.02e32fa1.jpg";